<template>
  <OktaLayout>
    <template #body>
      <div :data-test-id="dataTestId">
        <ContactJeopardy v-bind="props" :onBackClicked="handleBackClick" />
      </div>
    </template>
    <template #disclaimer>
      <div class="text-xs"><RichText :field="fields.Disclaimer" /></div>
    </template>
  </OktaLayout>
</template>

<script setup lang="ts">
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import { usePageStore } from '@/store';
import OktaLayout from '../OktaLayout/OktaLayout.vue';
import ContactJeopardy from './ContactJeopardy.vue';
import { RegistrationState } from '@/interfaces/pages/registration.interface';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

const props = defineProps<{
  fields?: ComponentFields;
  rendering?: ComponentRendering;
  state?: RegistrationState;
  isLockedOut?: boolean;
}>();

const dataTestId = usePageStore().dataTestId(props.rendering);

// ----------------------------------------------------------------------------------
// Functions
// ----------------------------------------------------------------------------------

function handleBackClick() {
  if (window && props.fields.ContactJeopardyBackToLink?.value?.href) {
    window.location.href = props.fields.ContactJeopardyBackToLink.value.href;
  }
}
</script>
